export var _descriptionTheme = {
  baseStyle: {
    textStyle: 'body4',
    color: 'neutral.darker',
    _invalid: {
      color: 'critical.main'
    },
    _readOnly: {
      color: 'neutral.darker'
    },
    _disabled: {
      color: 'neutral.light'
    }
  }
};
//# sourceMappingURL=_Description.theme.js.map